import { Action } from '../../actions';
import { mergeEntities, transformObjects } from '../../helpers';

import { transformUserRecentProjectsAndContests } from './recent-project-and-contests.transformers';

export function navigationUserRecentProjectsAndContestsReducer(
  state = {},
  action: Action,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'navigationUserRecentProjectsAndContests') {
        const { result, ref } = action.payload;
        return mergeEntities<'navigationUserRecentProjectsAndContests'>(
          state,
          transformObjects(result.list, transformUserRecentProjectsAndContests),
          ref,
        );
      }
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/datastore/navigation/recent-projects-and-contests/recent-projects-and-contests.reducer.ts